const defaultState = () => ({
    deals: [],
    leads: [],
    plans: [],
    reports: [],
    planTypes: []
});
export default defaultState;
